import { WEBSITES } from '@/constants/config';
import { CURRENCY_CODE } from '@/constants/currency';
import { PAYMENT_OPTIONS, SITE_PAYMENT_OPTIONS } from '@/constants/payment';

export const ConfigModule = {
    state: () => ({
        currencyCode: CURRENCY_CODE,
        config: {
            phone: '+855 88 468 8888',
            address:
                'F14, Keystone building, Norodom Blvd, Tonle Basak, Khan Chamkarmon, Phnom Penh',
            'address-en':
                'F14, Keystone building, Norodom Blvd, Tonle Basak, Khan Chamkarmon, Phnom Penh',
            'address-km':
                'Keystone ជាន់ទី 14 មហា វិថី ព្រះ នរោត្តម (៤១) <br> សង្កាត់ទន្លេបាសាក់ ខណ្ឌ ចំការមន ភំ្នពេញ',
            addressMap: 'https://goo.gl/maps/Y3UiikY3nWqTqVZo6',
            email: 'support@1byte.com',
            invoiceEmail: 'support@1byte.com',
            invoicePhone: '+855 88 468 8888',
        },
    }),
    getters: {
        isEnablePaymentCard(state, getters, rootState) {
            switch (rootState.website.currentWebsite?.id) {
                case WEBSITES.KH:
                    return (
                        process.env.VUE_APP_ENABLE_PAYMENT_METHOD_PAYWAY_PLUS?.toLowerCase() ===
                        'true'
                    );
                case WEBSITES.TH:
                    return (
                        process.env.VUE_APP_ENABLE_PAYMENT_METHOD_OMISE?.toLowerCase() ===
                            'true' &&
                        Object.values(SITE_PAYMENT_OPTIONS.TH).some(
                            (e) => e.key === PAYMENT_OPTIONS.OMISE.key
                        )
                    );
                case WEBSITES.AE:
                    return (
                        process.env.VUE_APP_ENABLE_STRIPE_METHOD?.toLowerCase() ===
                            'true' &&
                        Object.values(SITE_PAYMENT_OPTIONS.AE).some(
                            (e) => e.key === PAYMENT_OPTIONS.STRIPE.key
                        )
                    );
                default:
                    return false;
            }
        },
        siteConfig:
            (state) =>
            ({ websiteId }) => {
                const defaultSiteConfig = { ...state.config };
                let siteConfig = { ...defaultSiteConfig };
                if (websiteId === WEBSITES.TH) {
                    siteConfig = {
                        ...siteConfig,
                        invoicePhone: '+66 646286772',
                        address:
                            'No. 111/42 Soi Nawamin 111, Nawamin Sub-District<br>Bungkum District, Bangkok 10240, Thailand',
                        'address-en':
                            'No. 111/42 Soi Nawamin 111, Nawamin Sub-District<br>Bungkum District, Bangkok 10240, Thailand',
                        'address-km':
                            'No. 111/42 Soi Nawamin 111, Nawamin Sub-District<br>Bungkum District, Bangkok 10240, Thailand',
                        taxCode: '0105567129288',
                        companyName: 'K Zone Company Limited',
                        receivedWHTEmail: 'ar.collection@1byte.com',
                    };
                }
                return siteConfig;
            },
    },
    namespaced: true,
};
